export enum InternalProductViewMode {
  BASIC = 'basic',
  ASSOCIATED_COMPANIES = 'associated-companies',
  FLOWS = 'flows',
  GRAPH_CONTEXT = 'graph-context',
  PHRASES_TAGS = 'phrases-tags',
  TAGS = 'tags',
  ISIC_MAPPINGS = 'isic-mappings',
  ORGANIC_SCORES = 'organic-scores',
  CONSTRAINTS = 'constraints',
  EVENTS = 'events',
  PRIORS = 'priors',
  CSRD = 'csrd',
  REFERENCE_PRODUCTS = 'reference-products',
}
